export default "__VITE_ASSET__BpMzKJdB__"